import React, { useState } from 'react';
import { VisibilityOffRounded, VisibilityRounded } from '@mui/icons-material';

/**
 * Password field with a show/hide toggle. Facilitators type long generated
 * passwords on phones and had no way to see what they'd entered when a login
 * failed (2026-10-14), so every login form uses this instead of a bare
 * `type="password"` input.
 *
 * `className` styles the <input> exactly as the caller's other fields are
 * styled; the eye button is laid over its right edge.
 */
type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  /** Extra classes for the wrapper (e.g. a bottom margin the input used to carry). */
  wrapperClassName?: string;
};

const PasswordInput: React.FC<Props> = ({ className = '', wrapperClassName = '', ...inputProps }) => {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${wrapperClassName}`}>
      <input {...inputProps} type={show ? 'text' : 'password'} className={`${className} pr-10`} />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? 'Hide password' : 'Show password'}
        aria-pressed={show}
        tabIndex={-1}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-300"
      >
        {show ? <VisibilityOffRounded fontSize="small" /> : <VisibilityRounded fontSize="small" />}
      </button>
    </div>
  );
};

export default PasswordInput;
